import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FavoritesPage} from './favorites/favorites.component';
import {LoginDesktopComponent} from './login/login-desktop/login-desktop.component';
import {LoginPage} from './login/login.component';
import {MiniPlayerComponent} from './mini-player/mini-player.component';
import {PlayerComponent} from './player/player.component';
import {SchedulerPage} from './scheduler/scheduler.component';
import {SearchPage} from './search/search.component';
import {SettingsPage} from './settings/settings.component';
import {SidePanelComponent} from './side-panel/side-panel.component';
import {WishlistPage} from './wishlist/wishlist.component';
import {ZoneSelectionPage} from './zone-selection/zone-selection.component';
import {ImagesModule} from '../components/images/images.module';
import {ListsModule} from '../components/lists/lists.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DialogsModule} from '../components/dialogs/dialogs.module';
import {MatSliderModule} from '@angular/material/slider';
import {DirectivesModule} from '../directives/directives.module';
import {ButtonsModule} from '../components/buttons/buttons.module';
import {MwFormsModule} from '../components/forms/forms.module';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {PlaylistPickerComponent} from './playlist-picker/playlist-picker.component';
import {HttpClientModule} from '@angular/common/http';
import {SharedModule} from '../shared.module';
import {MatButtonModule} from '@angular/material/button';
import {PlaybackModule} from '../components/buttons/play-back-btn/playback.module';
import {MatInputModule} from '@angular/material/input';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {SyncSpinnerComponent} from './sync-spinner/sync-spinner.component';
import {HeaderModule} from '../components/header/header.module';
import {BreadcrumbModule} from '../components/breadcrumb/breadcrumb.module';
import {SchedulerModifierPage} from './scheduler-modifier/scheduler-modifier.component';
import {DuplicateDayPageComponent} from './duplicate-day-page/duplicate-day-page.component';
import {EditSchedulerPageComponent} from './edit-scheduler-page/edit-scheduler-page.component';
import {ComponentsModule} from '../components/components.module';
import {EditSlotPageComponent} from './edit-slot-page/edit-slot-page.component';
import {PendingChangesGuard} from '../guards/pending-changes.guard';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

/**
 * TODO :: Most of the components bellow must be in a ShareModule.
 */
@NgModule({
  providers: [PendingChangesGuard],
  declarations: [
    FavoritesPage,
    LoginDesktopComponent,
    LoginPage,
    MiniPlayerComponent,
    PlayerComponent,
    SchedulerPage,
    SearchPage,
    SettingsPage,
    SidePanelComponent,
    WishlistPage,
    ZoneSelectionPage,
    PlaylistPickerComponent,
    SyncSpinnerComponent,
    SchedulerModifierPage,
    DuplicateDayPageComponent,
    EditSchedulerPageComponent,
    EditSlotPageComponent,
  ],
  exports: [
    SidePanelComponent,
    PlayerComponent,
    SchedulerPage,
    BreadcrumbModule
  ],
  imports: [
    CommonModule,
    ImagesModule,
    ListsModule,
    SharedModule,
    ReactiveFormsModule,
    DialogsModule,
    MatSliderModule,
    DirectivesModule,
    ButtonsModule,
    MwFormsModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    PlaybackModule,
    MatProgressBarModule,
    NgOptimizedImage,
    HeaderModule,
    BreadcrumbModule,
    ComponentsModule,
    MatSlideToggleModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class ContainersModule { }
